import { Component, ViewChild, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { createAlertConfig } from 'src/app/shared/factoryconfigAlert';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertDurationWithRedirect } from 'src/app/shared/constant.shared';

@Component({
  selector: 'add-socio-group',
  templateUrl: './add-socio-group.component.html',
  styleUrls: ['./add-socio-group.component.css']
})
/** addSocioGroup component*/
export class AddSocioGroupComponent implements OnInit {

  @ViewChild('assignSocioForm', { static: true })
  formSendAssign: NgForm;
  
  idSocio: number;
  tessera: number;
  
  @ViewChild('addSocioForm', { static: true })
  formSendAdd: NgForm;

  socio: any;
  associazione: any;

  dateModel: Date;

  nazioni: any[];
  associazioni: any[];

  yearRange: string = "1900:2030"


  /** addSocioGroup ctor */
  constructor(@Inject(LOCALE_ID) public locale: string, private dataService: DataService, private alertservice: NwbAlertService,
    private route: ActivatedRoute, private router: Router) {

  }

  ngOnInit(): void {
    let currentYear = moment().year();
    this.yearRange = `${(currentYear - 110)}:${currentYear}`;

    this.route.data.subscribe(t => {
      this.nazioni = t.data[0];
      this.associazioni = t.data[1];
      this.socio = {
        sesso: 'M',
        codStato: 'IT'
      };
    });
  }

  assignSocio() {
    if (this.formSendAssign.invalid) {
      this.alertservice.open(createAlertConfig("Tutti i campi sono obbligatori", false)).afterClosed().subscribe();
      return;
    }

    if (this.idSocio < 1 || this.idSocio > 2147483647) {
      this.alertservice.open(createAlertConfig("Id socio non valido", false)).afterClosed().subscribe();
      return;
    }
    if (this.tessera < 1 || this.tessera > 2147483647) {
      this.alertservice.open(createAlertConfig("Tessera non valida", false)).afterClosed().subscribe();
      return;
    }

    this.dataService.assignSocioGruppo(this.idSocio, this.tessera).subscribe(() => {
      this.alertservice.open(createAlertConfig("Socio assegnato", true, AlertDurationWithRedirect)).afterClosed().subscribe(() => {
        this.router.navigate(['/area-utente', 'gruppo']);
      });
    }, (error) => {
      if(error.error) {

        this.alertservice.open(createAlertConfig(error.error, false)).afterClosed().subscribe();
        return;
      }

      if (this.locale == 'it') {
        this.alertservice.open(createAlertConfig("Errore non gestito. Provare a ricaricare la pagina. Se persiste contattare l'assistenza", false)).afterClosed().subscribe();
      } else {
        this.alertservice.open(createAlertConfig("Error not manage. Try to reload the current page. If persist contact the support", false)).afterClosed().subscribe();
      }
    });
  }

  addSocio() {
    if (this.formSendAdd.invalid) {
      this.alertservice.open(createAlertConfig("Controllare i campi", false)).afterClosed().subscribe();
      return;
    }
    
    let m = moment(this.dateModel);
    this.socio.natoIl = m.format('YYYY-MM-DD');
    this.dataService.addSocioGruppo(this.socio).subscribe(() => {
      this.alertservice.open(createAlertConfig("socio aggiunto", true, AlertDurationWithRedirect)).afterClosed().subscribe(() => {
        this.router.navigate(['/area-utente', 'gruppo']);
      });
    }, (error) => {
      if(error.error) {
        this.alertservice.open(createAlertConfig(error.error, false)).afterClosed().subscribe();
        return;
      }

      if (this.locale == 'it') {
        this.alertservice.open(createAlertConfig("Errore non gestito. Provare a ricaricare la pagina. Se persiste contattare l'assistenza", false)).afterClosed().subscribe();
      } else {
        this.alertservice.open(createAlertConfig("Error not manage. Try to reload the current page. If persist contact the support", false)).afterClosed().subscribe();
      }
    });
  }

  onChangeAssociazione(event: any) {
    if (event) {
      let associazioneNuova = this.associazioni.find(a => a.id == event);
      this.socio.idAssociazione = associazioneNuova.id;
      this.socio.nomeAssociazione = associazioneNuova.ragioneSociale;
    } else {
      this.socio.idAssociazione = this.socio.tesseraAssociazione = this.socio.nomeAssociazione = undefined;
    }
  }
}
